module.exports = __webpack_public_path__ + "img/hf-logo-3d.2c5b827.svg";